import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ScriptLoaderService } from '../../shared/script-loader/script-loader.service';
import { isNullOrUndefined } from '../../util/helpers';


let nextId = 0;

@Component({
  selector: 'app-skyvector-chart',
  templateUrl: './skyvector-chart.component.html',
  styleUrls: ['./skyvector-chart.component.scss']
})
export class SkyVectorChartComponent implements OnChanges {
  CONTAINER_ID: string;
  @Input() lat: number;
  @Input() lon: number;

  constructor(private _scriptLoader: ScriptLoaderService) {}

  private async _update() {
    if (!isNullOrUndefined(this.lat) && !isNullOrUndefined(this.lon)) {
      nextId++;
      this.CONTAINER_ID = 'appskyvector' + nextId;
      await this._scriptLoader.load(this.sectionalUrl);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.lat || changes.lon) {
      this._update();
    }
  }

  get sectionalUrl(): string {
    return `https://skyvector.com/perl/ad1?lat=${this.lat}&lon=${this.lon}&s=2&c=${this.CONTAINER_ID}&t=_blank`;
  }
}
